import React, { useState } from "react";
import SchoolSearch from "components/shared/SchoolSearch";

import { useNavigate } from "react-router-dom";
import ConfirmationPage from "../students/components/ConfirmationPage";

export default function SchoolsWelcome() {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const navigator = useNavigate();
  const [data, setData] = useState<any>({});

  return (
    <>
      {currentStep === 1 && (
        <SchoolSearch
          step="Step 1"
          title={"FIND YOUR SCHOOL"}
          onBack={() => {
            navigator("/");
          }}
          onNext={(data: any) => {
            setData(data);
            setCurrentStep(2);
          }}
          value={{ school: data.school }}
        />
      )}
      {currentStep === 2 && (
        <ConfirmationPage
          value={{
            user: data,
          }}
          onBack={() => setCurrentStep(1)}
          onNext={() => {
            window.location.href = "https://portal.heroicgameday.in/login";
          }}
        />
      )}
    </>
  );
}
